import Creatable from 'react-select/creatable';
import { withForm } from '@/core/form/withForm';

export const CreateSelect = withForm(Creatable);
